import { api } from '../api'

/**
 * Title data layer
 *
 * Provides methods to read and manipulate title data
 * Depends on an API module that provides HTTP methods
 */
const TitleAPI = () => {
    return {
        getVariations,
        createVariation,
        updateVariation,
        deleteVariation,
        getRelevantTitles,
        createRelevantTitle,
        updateRelevantTitle,
        deleteRelevantTitle,
        getUnclearIrrelevantTitles,
        createUnclearIrrelevantTitle,
        updateUnclearIrrelevantTitle,
        deleteUnclearIrrelevantTitle,
        publishTitles
    }

    /**
     *
     * @returns
     */
    async function getVariations() {
        const variations = await api.get(`/api/automation/title-variations`)

        return variations
    }

    /**
     * Create a new title variation
     * @param {object} titleVariation
     * @returns success or error details
     */
    async function createVariation(variationDetails) {
        const url = "/api/automation/title-variations"
        const data = compileVariationData(variationDetails)
        // submit form data
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Edit a title variation
     * @param {object} titleVariation
     * @returns success or error details
     */
    async function updateVariation(variationDetails, id) {
        console.log("variationDetails: ", variationDetails);
        const url = "/api/automation/title-variations/" + id
        const data = compileVariationData(variationDetails)
        
        // submit form data 
        return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Delete a title variation
     * @param {object} titleVariation
     * @returns success or error details
     */
    async function deleteVariation(id) {
        const response = await api.delete(`/api/automation/title-variations/${id}`)
        return response
    }
    


    /**
     *
     * @returns
     */
    async function getRelevantTitles() {
        const title = await api.get(`/api/automation/relevant-titles`)
        return title
    }

    /**
     * Create a new relevant title
     * @param {object} titleDetails of relevant title
     * @returns success or error details
     */
    async function createRelevantTitle(titleDetails) {
        const url = "/api/automation/relevant-titles"
        const data = compileRelevantData(titleDetails)
        // submit form data
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Edit a relevant title
     * @param {object} titleDetails of relevant title
     * @returns success or error details
     */
    async function updateRelevantTitle(titleDetails, id) {
        const url = "/api/automation/relevant-titles/" + id
        const data = compileRelevantData(titleDetails)
        // submit form data 
        return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Delete a relevant title
     * @param {object} id of relevant title
     * @returns success or error details
     */
    async function deleteRelevantTitle(id) {
        const response = await api.delete(`/api/automation/relevant-titles/${id}`)
        return response
    }


    /**
     *
     * @returns
     */
    async function getUnclearIrrelevantTitles(type) {
        const titles = await api.get(`/api/automation/unclear-irrelevant-titles?type=${type}`)

        return titles
    }

    /**
     * Create a new unclear or irrelevant title
     * @param {object} titleDetails
     * @returns success or error details
     */
    async function createUnclearIrrelevantTitle(titleDetails) {
        const url = "/api/automation/unclear-irrelevant-titles"
        const data = compileUnclearIrrelevantData(titleDetails)
        // submit form data
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Edit a unclear or irrelevant title
     * @param {object} titleDetails of unclear or irrelevant title
     * @returns success or error details
     */
    async function updateUnclearIrrelevantTitle(titleDetails, id) {
        const url = "/api/automation/unclear-irrelevant-titles/" + id
        const data = compileUnclearIrrelevantData(titleDetails)
        // submit form data 
        return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Delete a unclear or irrelevant title
     * @param {id} id of titleDetails of unclear or irrelevant title
     * @returns success or error details
     */
    async function deleteUnclearIrrelevantTitle(id) {
        const response = await api.delete(`/api/automation/unclear-irrelevant-titles/${id}`)
        return response
    }


    /**
     * Publish titles
     * @param {type} type of title to be published
     * @returns success or error details
     */
    async function publishTitles(type) {
        const url = "/api/automation/publish-titles"
        const data = compilePublishTitleData(type)
        // submit form data
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    
    }

}

const compilePublishTitleData = (type) => {
    const data = new FormData()
    data.append("type", type)
    return data
}

const compileVariationData = (variationDetails) => {
    const { initial, variations } = variationDetails
    const data = new FormData()
    data.append("initial", initial)
    data.append("variations", variations)
    return data
}

const compileUnclearIrrelevantData = (titleDetails) => {
    const { title, status } = titleDetails
    const data = new FormData()
    data.append("title", title)
    data.append("status", status)
    return data
}

const compileRelevantData = (titleDetails) => {
    const { initial, main, end } = titleDetails
    const data = new FormData()
    if (initial) data.append("initial", initial)
    if (main) data.append("main", main)
    if (end) data.append("end", end)
    return data
}
export default TitleAPI
